import { Play, ArrowRight } from "lucide-react";
import { SITE } from "../data/site";
import { Overline, SectionTitle, Accent, Reveal } from "./Reveal";

export const ClubVideos = () => (
  <section className="relative py-24 sm:py-32 bg-[#061A14]" data-testid="club-videos-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Overline>iGreen Club</Overline>
        <SectionTitle className="max-w-3xl">
          Benefícios exclusivos para quem é cliente, <Accent>no iGreen Club</Accent>.
        </SectionTitle>
        <p className="mt-4 max-w-2xl text-sm sm:text-base text-emerald-100/55">
          Quem tem a Conexão Green ganha acesso ao clube de descontos da iGreen, com ofertas em milhares de parceiros em todo o Brasil. Veja quem já usa:
        </p>
      </Reveal>
      <div className="mt-14 grid grid-cols-2 lg:grid-cols-3 gap-5">
        {SITE.clubVideos.map((id, i) => (
          <Reveal key={id} delay={i * 0.07}>
            <a
              href={`https://www.youtube.com/watch?v=${id}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`club-video-${i}`}
              className="group relative block rounded-2xl overflow-hidden border border-white/10 transition-[border-color,transform] duration-300 hover:border-[#00E676]/45 hover:-translate-y-1.5"
            >
              <div className="aspect-video">
                <img
                  src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`}
                  alt={`Depoimento iGreen Club ${i + 1}`}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-108"
                />
              </div>
              <div className="absolute inset-0 bg-[#04120E]/30 group-hover:bg-[#04120E]/10 transition-colors duration-300" />
              <span className="absolute inset-0 grid place-items-center">
                <span className="grid place-items-center w-12 h-12 rounded-full bg-[#00E676]/90 text-[#04120E] transition-transform duration-300 group-hover:scale-110">
                  <Play size={17} className="ml-0.5" />
                </span>
              </span>
              <span className="absolute bottom-3 left-3 text-[10px] font-mono2 uppercase tracking-widest text-white/85 bg-[#04120E]/70 backdrop-blur px-2.5 py-1 rounded-full">
                Depoimento iGreen Club · {String(i + 1).padStart(2, "0")}
              </span>
            </a>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.1}>
        <a
          href="#conectar"
          data-testid="club-guarantee-cta"
          className="mt-12 inline-flex items-center gap-2 rounded-full bg-[#00E676] hover:bg-[#00C853] text-[#04120E] font-bold px-7 py-4 shadow-[0_0_24px_rgba(0,230,118,0.4)] transition-[background-color,transform] duration-300 hover:scale-[1.03]"
        >
          Garantir minha economia <ArrowRight size={17} />
        </a>
        <p className="mt-5 text-[11px] text-emerald-100/40">Vídeos oficiais da iGreen Energy. Ofertas e cupons dependem dos parceiros do clube.</p>
      </Reveal>
    </div>
  </section>
);
